module.exports = __webpack_public_path__ + "img/hr.04d0ef95.png";